import { render } from "./ListeAttestation.vue?vue&type=template&id=e8ec25e8&ts=true"
import script from "./ListeAttestation.vue?vue&type=script&lang=ts"
export * from "./ListeAttestation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__